import { MutableRefObject, useRef, useState } from 'react'
import { useScrollPosition } from '.'

export const useIsSticky = <T>(ref: MutableRefObject<(T & HTMLElement) | null>) => {
  const [isSticky, setIsSticky] = useState(false)
  const topRef = useRef(0)

  useScrollPosition(() => {
    const top = ref.current?.getBoundingClientRect().top ?? 0
    // if a scroll has occured but the position realtive to
    // the viewport did not change, the element is sticky
    setIsSticky(top === topRef.current)
    topRef.current = top
  })

  return {
    isSticky,
  }
}
